import { PiLocation } from "../Types/PiLocation";

export async function fetchLocations() {
    const apiUrl = process.env.REACT_APP_API_URL;
    let url = `${apiUrl}/teams/locations`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (response.ok) {
            const locations: PiLocation[] = await response.json();
            return locations;
        }
    }
    catch (error) {
        console.error(error);
    }
    return [];
}

export async function fetchMachineLocations() {
    const apiUrl = process.env.REACT_APP_API_URL;
    let url = `${apiUrl}/teams/machineLocations`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (response.ok) {
            const locations: PiLocation[] = await response.json();
            return locations.map((loc) => {
                const pos = loc.Location.split(',');
                const x = parseFloat(pos[0]);
                const y = parseFloat(pos[1]);

                return {
                    x: x,
                    y: y,
                    machineId: loc.ElementName,
                    guid: loc.Guid,
                    pdp1Guid: loc.Pdp1Guid
                };
            });
        }
    }
    catch (error) {
        console.error(error);
    }
    return [];
}